export default __webpack_public_path__ + "static/media/Border Kingdom Headgear.f8f6be8b.jpg";